import { render, staticRenderFns } from "./reversalTable.vue?vue&type=template&id=62008960&"
import script from "./reversalTable.vue?vue&type=script&lang=js&"
export * from "./reversalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VDataTable,VDivider,VTextField,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3554887359/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62008960')) {
      api.createRecord('62008960', component.options)
    } else {
      api.reload('62008960', component.options)
    }
    module.hot.accept("./reversalTable.vue?vue&type=template&id=62008960&", function () {
      api.rerender('62008960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BatchTables/reversalTable.vue"
export default component.exports